export const COMMON_PATIENT_INCLUDES = [
  'user',
  'patient_status',
  'organization',
  'rx_form.location',
  'rx_form.shipping_location',
  'customer_request.printing_request.location',
  'customer_request.printing_request',
  'rx_form.custom_bracket_set'
];
